import * as React from 'react'

export default () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.97461 12.4879C2.97461 9.94296 5.03768 7.87988 7.58261 7.87988C10.1275 7.87988 12.1906 9.94295 12.1906 12.4879V17.0959C12.1906 18.3683 11.1591 19.3999 9.88661 19.3999H5.27861C4.00614 19.3999 2.97461 18.3683 2.97461 17.0959V12.4879Z"
      fill="#8FB4FF"
    />
    <path
      d="M15.6465 12.4879C15.6465 9.94296 17.7096 7.87988 20.2545 7.87988C22.7994 7.87988 24.8625 9.94295 24.8625 12.4879V17.0959C24.8625 18.3683 23.8309 19.3999 22.5585 19.3999H17.9505C16.678 19.3999 15.6465 18.3683 15.6465 17.0959V12.4879Z"
      fill="#8FB4FF"
    />
    <path d="M12.1895 3.27148V24.0075" stroke="#8FB4FF" strokeWidth="1.5" strokeDasharray="1.15 1.15" />
    <path d="M15.6465 3.27148V24.0075" stroke="#8FB4FF" strokeWidth="1.5" strokeDasharray="1.15 1.15" />
  </svg>
)
